import { format } from "date-fns"

export const formatDate = (isoDate: string, pretty = true) => {
	if (!pretty) return format(new Date(isoDate), "d.M.yyyy")
	return format(new Date(isoDate), "d. LLLL yyyy")
}
